import { CrispClass } from "crisp-sdk-web";
import { createContext } from "react";

export type ContextValue = {
  readonly crisp: CrispClass;

  // The Crisp widget stores its own state separately from React
  // For any app logic that needs to access the Crisp state, we need to track within React's state system
  readonly isChatOpened: boolean;
};

const CrispContext = createContext<ContextValue>({
  // @ts-expect-error This is intentional
  crisp: undefined,

  isChatOpened: false,
});

export default CrispContext;
